import styled from "styled-components"

const StyledFlex = styled.div`
  margin-top: 10px;
`

const StyledFlexGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
`

const StyledFlexItem = styled.div<{ $colSpan?: number }>`
  --width-column: ${({ $colSpan = 1 }) => `calc(20% * ${$colSpan} - 20px)`};
  flex-basis: var(--width-column);
  max-width: var(--width-column);
  width: var(--width-column);
  > .ant-form-item {
    > .ant-form-item-row {
      > .ant-form-item-label {
        width: initial;
        height: initial;
        min-width: 100%;
        text-indent: initial;
        > label {
          justify-content: flex-start;
          height: initial;
          .form-label {
            flex-grow: initial;
          }
        }
      }
    }
  }
  .ant-form-item {
    margin-top: 0;
  }
`

export const Styled = {
  StyledFlex,
  StyledFlexGroup,
  StyledFlexItem,
}
